exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-data-bank-dataset-detail-content-___copy-to-dashboard__container___3103l {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 202px;\n}\n\n.src-components-data-bank-dataset-detail-content-___copy-to-dashboard__button___dua_1 {\n  float: right;\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-data-bank-dataset-detail-content-___copy-to-dashboard__container___3103l",
	"button": "src-components-data-bank-dataset-detail-content-___copy-to-dashboard__button___dua_1"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/data-bank/dataset-detail/content/copy-to-dashboard.scss
// module id = 2229
// module chunks = 0